import { render, staticRenderFns } from "./feedbackActivity.vue?vue&type=template&id=2b0fcc44&scoped=true&"
import script from "./feedbackActivity.vue?vue&type=script&lang=js&"
export * from "./feedbackActivity.vue?vue&type=script&lang=js&"
import style0 from "./feedbackActivity.vue?vue&type=style&index=0&id=2b0fcc44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0fcc44",
  null
  
)

export default component.exports